import { render, staticRenderFns } from "./modal-permissions.component.html?vue&type=template&id=0fd76f0b&scoped=true&"
import script from "./modal-permissions.component.ts?vue&type=script&lang=ts&"
export * from "./modal-permissions.component.ts?vue&type=script&lang=ts&"
import style0 from "./modal-permissions.component.scss?vue&type=style&index=0&id=0fd76f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd76f0b",
  null
  
)

export default component.exports